import { useCallback } from "react"
import { useAxiosInstances } from "../../axios-instance"
import { IAnaliseRecorte, IRecorteExtracao } from "../../../application/models"

export const useRecortesExtracaoApi = () => {
    // Axios Instance
    const { axiosAuthInstance } = useAxiosInstances()

    const findRecorteExtracaoApi = useCallback(async (data: {
        IdVelesGeoProjeto: string
    }): Promise<IRecorteExtracao> => {
        try {
            const result = await axiosAuthInstance.get(`/geo-veles/projeto/recorte/${data.IdVelesGeoProjeto}`)
            return result.data.recorteExtracao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const setRecorteExtracaoApi = useCallback(async (data: {
        recorteExtracao: Partial<IRecorteExtracao>
    }): Promise<IRecorteExtracao> => {
        try {
            const result = await axiosAuthInstance.post('/geo-veles/projeto/recorte', {
                recorteExtracao: data.recorteExtracao
            })

            return result.data.recorteExtracao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const getAnaliseRecorteExtracaoApi = useCallback(async (data: {
        recorteExtracao: IRecorteExtracao
    }): Promise<{
        recorteExtracao: IRecorteExtracao
        recorteErrors: IAnaliseRecorte[]
        recortesDisponiveis: IAnaliseRecorte[]
    }> => {
        try {

            const result = await axiosAuthInstance.put('/geo-veles/projeto/recorte/analisar', {
                recorteExtracao: data.recorteExtracao
            })

            return {
                recorteExtracao: result.data.recorteExtracao,
                recorteErrors: result.data.recorteErrors,
                recortesDisponiveis: result.data.recortesDisponiveis
            }
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        findRecorteExtracaoApi,
        setRecorteExtracaoApi,
        getAnaliseRecorteExtracaoApi
    }
}